import { render, staticRenderFns } from "./tax.vue?vue&type=template&id=7ddab504&scoped=true&"
import script from "./tax.vue?vue&type=script&lang=js&"
export * from "./tax.vue?vue&type=script&lang=js&"
import style0 from "./tax.vue?vue&type=style&index=0&id=7ddab504&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddab504",
  null
  
)

export default component.exports